import { render, staticRenderFns } from "./ImportProductPOModal.vue?vue&type=template&id=a23251b0&"
import script from "./ImportProductPOModal.vue?vue&type=script&lang=js&"
export * from "./ImportProductPOModal.vue?vue&type=script&lang=js&"
import style0 from "./ImportProductPOModal.vue?vue&type=style&index=0&id=a23251b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports